import axios from "./axios";

export const getEksList = async () => {
  try {
    const data = await axios.get("/api/v1/provision/eks");
    if(data.status === "OK" && data.value) {
      data.value.forEach((item) =>{
        item.id = item.name;
      })
    }
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getEksStatus = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/eks/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};